/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Quick_Stock_In_FailedInputs */

const vi_warehouse_quick_stock_in_failed = /** @type {(inputs: Warehouse_Quick_Stock_In_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể nhập kho — kiểm tra vị trí, sản phẩm rồi thử lại.`)
};

/**

* @param {Warehouse_Quick_Stock_In_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_quick_stock_in_failed = /** @type {((inputs?: Warehouse_Quick_Stock_In_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Quick_Stock_In_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_quick_stock_in_failed(inputs)
});